const env = process.env.NPP_ENV || 'prod';
let baseApiUrl;
let apiUrl = '';
let authUrl;
let appClientId;
let baseUrl;
if (env === 'prod') {
  baseApiUrl = 'https://api.parklers.com';
  baseUrl = 'com.national.parks.passport://';
  baseUrl = 'https://app.parklers.com/'
  appClientId = '3dmjqiphoev3ld0utdhjenkhhl';
  apiUrl = `${baseApiUrl}/v2/api`;
  authUrl = 'https://authv2.parklers.com';
}

let cb = `${baseUrl}profile`;
let logoutCb = `${baseUrl}profile?signout=true`;
// alert(window.location.host);
// if (window.location.host.indexOf('localhost:3000') >= 0) {
//   cb = 'http://localhost:3000/profile';
//   logoutCb = 'http://localhost:3000/profile?signout=true';
//   apiUrl = 'http://localhost:3001/v2/api';
//   baseApiUrl = 'http://localhost:3001';
// }

// if (env === 'dev') {
//   apiUrl = 'https://devapi.parklers.com';
// }

const tokenUrl = `${authUrl}/oauth2/token`;
const loginUrl = `${authUrl}/login?response_type=code&client_id=${appClientId}&redirect_uri=${cb}`;
const logoutUrl = `${authUrl}/logout?client_id=${appClientId}&logout_uri=${logoutCb}`;
const signUpUrl = `${authUrl}/signup?response_type=code&client_id=${appClientId}&redirect_uri=${cb}`;
const refreshTokenUrl = `${authUrl}/oauth2/token?response_type=token&client_id=${appClientId}&redirect_uri=${cb}`;
const tokensParameterBody = `grant_type=authorization_code&client_id=${appClientId}&redirect_uri=${cb}`;
const refreshParameterBody = `grant_type=refresh_token&client_id=${appClientId}&redirect_uri=${cb}`;
const openApiUrl = baseApiUrl + '/oapi';
export {
  openApiUrl,
  refreshParameterBody,
  tokensParameterBody,
  tokenUrl,
  apiUrl,
  loginUrl,
  logoutUrl,
  signUpUrl,
  refreshTokenUrl,
};
